export interface ProductFeature {
  title: string;
  desc: string;
}

export interface ProductSpec {
  label: string;
  value: string;
}

export interface Product {
  id: string;
  name: string;
  series: string;
  tagline: string;
  price: string;
  weight: string;
  summary: string;
  cover: string;
  gallery: string[];
  description: string[];
  features: ProductFeature[];
  specs: ProductSpec[];
  usage: string[];
  scenes: string[];
}

export const productSeries = [
  { key: "all", label: "全部产品" },
  { key: "软糖系列", label: "软糖系列" },
  { key: "烘焙系列", label: "烘焙系列" },
  { key: "巧克力系列", label: "巧克力系列" },
  { key: "饮品系列", label: "饮品系列" },
];

export const products: Product[] = [
  {
    id: "berry-gummy",
    name: "糖心莓莓夹心软糖",
    series: "软糖系列",
    tagline: "一口爆浆的草莓惊喜",
    price: "¥39",
    weight: "180g / 盒",
    summary: "外层是柔韧果汁软糖，内芯是真实草莓果酱夹心，酸甜平衡不齁甜。",
    cover: "https://readdy.ai/api/search-image?query=Premium%20strawberry%20filled%20gummy%20candies%20in%20an%20open%20warm%20coral%20gift%20box%20on%20a%20clean%20soft%20cream%20background%2C%20fresh%20strawberries%20beside%2C%20soft%20natural%20studio%20light%2C%20appetizing%20food%20photography%2C%20high%20detail%2C%20harmonious%20warm%20tone&width=900&height=900&seq=tx-product-gummy-cover&orientation=squarish",
    gallery: [
      "https://readdy.ai/api/search-image?query=Premium%20strawberry%20filled%20gummy%20candies%20in%20an%20open%20warm%20coral%20gift%20box%20on%20a%20clean%20soft%20cream%20background%2C%20fresh%20strawberries%20beside%2C%20soft%20natural%20studio%20light%2C%20appetizing%20food%20photography&width=900&height=900&seq=tx-gummy-g1&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Close%20up%20macro%20shot%20of%20glossy%20pink%20strawberry%20gummy%20candy%20with%20juicy%20jam%20center%20cut%20open%2C%20clean%20pale%20cream%20background%2C%20soft%20studio%20lighting%2C%20vivid%20appetizing%20food%20photography&width=900&height=900&seq=tx-gummy-g2&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Scattered%20colorful%20fruit%20gummy%20candies%20with%20a%20coral%20pouch%20on%20a%20minimal%20warm%20white%20surface%2C%20top%20view%2C%20bright%20soft%20light%2C%20clean%20product%20photography&width=900&height=900&seq=tx-gummy-g3&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Hand%20holding%20a%20single%20pink%20strawberry%20gummy%20candy%20against%20a%20soft%20blurred%20cream%20background%2C%20lifestyle%20candy%20photography%20with%20warm%20natural%20light&width=900&height=900&seq=tx-gummy-g4&orientation=squarish",
    ],
    description: [
      "糖心莓莓夹心软糖是糖心VLGO最受欢迎的代表作之一。我们选用当季新鲜草莓慢熬成酱，保留果肉颗粒，注入柔韧的果汁软糖外壳，做出「一口咬下会爆浆」的口感。",
      "配方坚持少糖少添加，酸甜比经过 27 次调整，只为找到那个吃完一颗还想再来一颗的平衡点。",
    ],
    features: [
      { title: "真实果酱夹心", desc: "内芯为慢熬草莓果酱，含真实果肉颗粒，风味自然。" },
      { title: "柔韧不粘牙", desc: "外层软糖弹性适中，咀嚼顺滑，不粘牙、不齁甜。" },
      { title: "少糖配方", desc: "相较传统软糖减糖约 30%，酸甜更清爽。" },
      { title: "独立小包装", desc: "每颗独立封装，便于携带分享，锁住新鲜口感。" },
    ],
    specs: [
      { label: "净含量", value: "180g（约 30 颗）/ 盒" },
      { label: "主要配料", value: "草莓果酱、白砂糖、麦芽糖浆、浓缩果汁、果胶" },
      { label: "保质期", value: "12 个月" },
      { label: "储存方式", value: "阴凉干燥处密封保存，避免阳光直射" },
      { label: "过敏原提示", value: "本产品含乳制品，可能含有微量坚果" },
    ],
    usage: [
      "开盒即食，建议冷藏后风味更佳。",
      "搭配咖啡或茶饮，作为下午茶小点。",
      "可作为伴手礼、生日礼赠或节日分享。",
    ],
    scenes: ["下午茶小食", "办公室零食", "节日伴手礼", "亲子分享"],
  },
  {
    id: "butter-cookie",
    name: "手工黄油曲奇礼盒",
    series: "烘焙系列",
    tagline: "用心的酥松，入口即化",
    price: "¥68",
    weight: "320g / 盒",
    summary: "选用进口发酵黄油，低温慢烤，酥松细腻，奶香浓郁而不腻。",
    cover: "https://readdy.ai/api/search-image?query=Assorted%20golden%20butter%20cookies%20neatly%20arranged%20in%20an%20elegant%20cream%20tin%20box%2C%20clean%20soft%20beige%20background%2C%20warm%20soft%20studio%20light%2C%20premium%20bakery%20food%20photography%2C%20high%20detail&width=900&height=900&seq=tx-product-cookie-cover&orientation=squarish",
    gallery: [
      "https://readdy.ai/api/search-image?query=Assorted%20golden%20butter%20cookies%20neatly%20arranged%20in%20an%20elegant%20cream%20tin%20box%2C%20clean%20soft%20beige%20background%2C%20warm%20soft%20studio%20light%2C%20premium%20bakery%20food%20photography&width=900&height=900&seq=tx-cookie-g1&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Macro%20close%20up%20of%20a%20crumbly%20golden%20butter%20cookie%20broken%20in%20half%20showing%20flaky%20texture%2C%20clean%20pale%20cream%20background%2C%20soft%20studio%20lighting%2C%20appetizing%20food%20photography&width=900&height=900&seq=tx-cookie-g2&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Stack%20of%20golden%20butter%20cookies%20with%20a%20cup%20of%20tea%20on%20a%20minimal%20warm%20white%20table%2C%20soft%20natural%20light%2C%20cozy%20lifestyle%20food%20photography&width=900&height=900&seq=tx-cookie-g3&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20butter%20cookies%20scattered%20near%20a%20cream%20gift%20tin%20on%20warm%20white%20surface%2C%20top%20view%2C%20bright%20soft%20light%2C%20clean%20product%20photography&width=900&height=900&seq=tx-cookie-g4&orientation=squarish",
    ],
    description: [
      "手工黄油曲奇礼盒选用进口发酵黄油，搭配低筋小麦粉，由烘焙师手工挤花、低温慢烤。出炉后的曲奇纹理清晰，奶香层层递进。",
      "礼盒内含原味、咸香芝士、可可三种口味，酥松细腻，入口即化，是送礼与自享都合适的选择。",
    ],
    features: [
      { title: "进口发酵黄油", desc: "奶香醇厚自然，风味更有层次。" },
      { title: "低温慢烤", desc: "精准控温烘烤，成就酥松细腻的口感。" },
      { title: "三种口味", desc: "原味、咸香芝士、可可，一盒尝尽。" },
      { title: "精致礼盒", desc: "磁吸开合礼盒设计，送礼体面大方。" },
    ],
    specs: [
      { label: "净含量", value: "320g / 盒（约 48 枚）" },
      { label: "主要配料", value: "小麦粉、发酵黄油、白砂糖、鸡蛋、芝士粉、可可粉" },
      { label: "保质期", value: "60 天" },
      { label: "储存方式", value: "常温阴凉处保存，开盒后建议 7 天内食用完" },
      { label: "过敏原提示", value: "含小麦、乳制品、蛋类" },
    ],
    usage: [
      "开盒可直接享用，亦可微波 10 秒回温更香。",
      "搭配红茶、咖啡或牛奶风味更佳。",
      "建议作为伴手礼、节庆礼赠。",
    ],
    scenes: ["下午茶", "节庆送礼", "办公室分享", "家庭聚会"],
  },
  {
    id: "salted-caramel-nougat",
    name: "海盐焦糖牛轧糖",
    series: "烘焙系列",
    tagline: "咸甜交织的温柔力量",
    price: "¥45",
    weight: "200g / 盒",
    summary: "慢炒焦糖碰撞海盐颗粒，夹入酥脆坚果，咸甜平衡、越嚼越香。",
    cover: "https://readdy.ai/api/search-image?query=Handmade%20sea%20salt%20caramel%20nougat%20cubes%20with%20nuts%20in%20a%20cream%20box%2C%20clean%20soft%20beige%20background%2C%20warm%20soft%20studio%20light%2C%20appetizing%20confectionery%20food%20photography%2C%20high%20detail&width=900&height=900&seq=tx-product-nougat-cover&orientation=squarish",
    gallery: [
      "https://readdy.ai/api/search-image?query=Handmade%20sea%20salt%20caramel%20nougat%20cubes%20with%20nuts%20in%20a%20cream%20box%2C%20clean%20soft%20beige%20background%2C%20warm%20soft%20studio%20light%2C%20appetizing%20confectionery%20food%20photography&width=900&height=900&seq=tx-nougat-g1&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Macro%20close%20up%20of%20a%20chewy%20caramel%20nougat%20cube%20torn%20in%20half%20showing%20nuts%2C%20clean%20pale%20cream%20background%2C%20soft%20studio%20lighting%2C%20appetizing%20food%20photography&width=900&height=900&seq=tx-nougat-g2&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Neatly%20stacked%20caramel%20nougat%20squares%20wrapped%20in%20warm%20paper%20on%20a%20minimal%20white%20surface%2C%20bright%20soft%20light%2C%20clean%20product%20photography&width=900&height=900&seq=tx-nougat-g3&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20caramel%20nougat%20cubes%20and%20almonds%20scattered%20near%20a%20cream%20gift%20box%20on%20warm%20white%20surface%2C%20top%20view%2C%20soft%20light&width=900&height=900&seq=tx-nougat-g4&orientation=squarish",
    ],
    description: [
      "海盐焦糖牛轧糖把焦糖的焦香与海盐的微咸完美结合。焦糖由小锅慢炒，糖体柔韧拉丝，再加入烘烤过的杏仁与腰果，口感层次丰富。",
      "咸甜比例反复调试，让每一口都不单调，是配茶配咖啡的绝佳搭档。",
    ],
    features: [
      { title: "小锅慢炒焦糖", desc: "焦香浓郁，风味纯净不含糊。" },
      { title: "海盐提味", desc: "微量海盐中和甜腻，咸甜更平衡。" },
      { title: "真材实料坚果", desc: "整颗烘烤杏仁与腰果，酥脆十足。" },
      { title: "柔韧拉丝", desc: "糖体软硬适中，久嚼不累。" },
    ],
    specs: [
      { label: "净含量", value: "200g（约 24 块）/ 盒" },
      { label: "主要配料", value: "麦芽糖浆、白砂糖、淡奶油、杏仁、腰果、海盐、蛋白" },
      { label: "保质期", value: "90 天" },
      { label: "储存方式", value: "常温阴凉处保存，避免高温软化" },
      { label: "过敏原提示", value: "含乳制品、蛋类、坚果" },
    ],
    usage: [
      "独立包装随取随吃，建议常温食用。",
      "搭配黑咖啡或乌龙茶，风味最佳。",
      "糖果较黏，建议冷藏后切割更整齐。",
    ],
    scenes: ["办公零食", "旅行携带", "茶点搭配", "节日分享"],
  },
  {
    id: "peach-soda",
    name: "白桃气泡饮",
    series: "饮品系列",
    tagline: "气泡迸发的清爽桃子",
    price: "¥19",
    weight: "330ml / 罐",
    summary: "真实白桃果汁搭配细腻气泡，清爽不甜腻，冰镇后一口醒神。",
    cover: "https://readdy.ai/api/search-image?query=Chilled%20peach%20sparkling%20drink%20in%20a%20slim%20coral%20can%20with%20fresh%20peach%20and%20ice%2C%20clean%20soft%20cream%20background%2C%20studio%20light%2C%20refreshing%20beverage%20product%20photography%2C%20high%20detail&width=900&height=900&seq=tx-product-soda-cover&orientation=squarish",
    gallery: [
      "https://readdy.ai/api/search-image?query=Chilled%20peach%20sparkling%20drink%20in%20a%20slim%20coral%20can%20with%20fresh%20peach%20and%20ice%2C%20clean%20soft%20cream%20background%2C%20studio%20light%2C%20refreshing%20beverage%20product%20photography&width=900&height=900&seq=tx-soda-g1&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Pouring%20peach%20sparkling%20drink%20into%20a%20clear%20glass%20with%20bubbles%20and%20ice%2C%20clean%20pale%20cream%20background%2C%20soft%20studio%20lighting%2C%20refreshing%20drink%20photography&width=900&height=900&seq=tx-soda-g2&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Cold%20peach%20soda%20cans%20in%20ice%20water%20with%20mint%20leaves%20on%20a%20minimal%20white%20surface%2C%20bright%20soft%20light%2C%20summer%20beverage%20photography&width=900&height=900&seq=tx-soda-g3&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Fresh%20peaches%20and%20a%20coral%20soda%20can%20on%20a%20warm%20white%20table%2C%20summer%20lifestyle%20drink%20photography%20with%20soft%20natural%20light&width=900&height=900&seq=tx-soda-g4&orientation=squarish",
    ],
    description: [
      "白桃气泡饮选用真实白桃汁，果香清甜自然，搭配细腻绵密的气泡，入口是桃子香，回味是清爽。",
      "低热量配方，无负担畅饮，冰镇后风味更出色。",
    ],
    features: [
      { title: "真实白桃汁", desc: "添加真实果汁，果香自然不刺鼻。" },
      { title: "细腻气泡", desc: "气泡绵密柔和，入口更顺滑。" },
      { title: "低热量", desc: "控糖配方，畅饮无负担。" },
      { title: "纤巧罐身", desc: "330ml 便携罐装，冰柜友好。" },
    ],
    specs: [
      { label: "净含量", value: "330ml / 罐" },
      { label: "主要配料", value: "碳酸水、白桃浓缩汁、白砂糖、柠檬酸、天然香料" },
      { label: "保质期", value: "9 个月" },
      { label: "储存方式", value: "常温保存，冷藏后饮用风味更佳" },
      { label: "过敏原提示", value: "无已知过敏原" },
    ],
    usage: [
      "冰镇后直接饮用，清爽加倍。",
      "可搭配柠檬片、薄荷叶调饮。",
      "开罐后请尽快饮用完毕。",
    ],
    scenes: ["夏日解渴", "聚餐配饮", "下午提神", "派对饮品"],
  },
  {
    id: "cocoa-crisp",
    name: "可可脆脆棒",
    series: "巧克力系列",
    tagline: "咔嚓一声的浓郁可可",
    price: "¥25",
    weight: "150g / 盒",
    summary: "威化夹心裹上厚层可可巧克力，外层脆、内里酥，可可香浓厚。",
    cover: "https://readdy.ai/api/search-image?query=Chocolate%20coated%20crispy%20wafer%20snack%20sticks%20stacked%20in%20a%20cream%20box%2C%20clean%20soft%20beige%20background%2C%20warm%20soft%20studio%20light%2C%20appetizing%20snack%20food%20photography%2C%20high%20detail&width=900&height=900&seq=tx-product-crisp-cover&orientation=squarish",
    gallery: [
      "https://readdy.ai/api/search-image?query=Chocolate%20coated%20crispy%20wafer%20snack%20sticks%20stacked%20in%20a%20cream%20box%2C%20clean%20soft%20beige%20background%2C%20warm%20soft%20studio%20light%2C%20appetizing%20snack%20food%20photography&width=900&height=900&seq=tx-crisp-g1&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Macro%20close%20up%20of%20a%20crispy%20wafer%20stick%20broken%20in%20half%20showing%20layers%20and%20chocolate%20coating%2C%20clean%20pale%20cream%20background%2C%20soft%20studio%20lighting&width=900&height=900&seq=tx-crisp-g2&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Chocolate%20wafer%20sticks%20in%20a%20clear%20cup%20on%20a%20minimal%20white%20surface%2C%20bright%20soft%20light%2C%20clean%20product%20photography&width=900&height=900&seq=tx-crisp-g3&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20chocolate%20wafer%20sticks%20scattered%20near%20a%20cream%20box%20on%20warm%20white%20surface%2C%20top%20view%2C%20soft%20light&width=900&height=900&seq=tx-crisp-g4&orientation=squarish",
    ],
    description: [
      "可可脆脆棒将多层威化与浓郁可可巧克力结合，外层丝滑、内里酥脆，咬下去咔嚓作响。",
      "采用可可脂含量更高的巧克力涂层，入口即化，可可香气层层铺开。",
    ],
    features: [
      { title: "厚层巧克力", desc: "高可可脂涂层，入口顺滑丝滑。" },
      { title: "多层威化", desc: "层层酥脆，口感富有节奏。" },
      { title: "独立包装", desc: "单支封装，干净便携不沾手。" },
      { title: "浓郁可可", desc: "可可香醇厚，微苦回甘。" },
    ],
    specs: [
      { label: "净含量", value: "150g（约 20 支）/ 盒" },
      { label: "主要配料", value: "小麦粉、白砂糖、可可脂、可可粉、植物油、乳粉" },
      { label: "保质期", value: "10 个月" },
      { label: "储存方式", value: "阴凉干燥处保存，避免高温融化" },
      { label: "过敏原提示", value: "含小麦、乳制品、大豆" },
    ],
    usage: [
      "开盒即食，避免高温环境存放。",
      "搭配牛奶或咖啡，风味更浓。",
      "可冷藏后食用，口感更脆。",
    ],
    scenes: ["办公零食", "追剧小食", "儿童点心", "旅行携带"],
  },
  {
    id: "matcha-cookie",
    name: "抹茶白巧曲奇",
    series: "烘焙系列",
    tagline: "抹茶微苦，白巧温柔",
    price: "¥42",
    weight: "160g / 盒",
    summary: "宇治抹茶粉融入酥松曲奇，点缀白巧克力豆，茶香清雅不甜腻。",
    cover: "https://readdy.ai/api/search-image?query=Green%20matcha%20cookies%20with%20white%20chocolate%20chips%20arranged%20in%20a%20cream%20box%2C%20clean%20soft%20beige%20background%2C%20warm%20soft%20studio%20light%2C%20premium%20bakery%20food%20photography%2C%20high%20detail&width=900&height=900&seq=tx-product-matcha-cover&orientation=squarish",
    gallery: [
      "https://readdy.ai/api/search-image?query=Green%20matcha%20cookies%20with%20white%20chocolate%20chips%20arranged%20in%20a%20cream%20box%2C%20clean%20soft%20beige%20background%2C%20warm%20soft%20studio%20light%2C%20premium%20bakery%20food%20photography&width=900&height=900&seq=tx-matcha-g1&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Macro%20close%20up%20of%20a%20matcha%20cookie%20broken%20in%20half%20showing%20white%20chocolate%20chips%2C%20clean%20pale%20cream%20background%2C%20soft%20studio%20lighting%2C%20appetizing%20food%20photography&width=900&height=900&seq=tx-matcha-g2&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Stack%20of%20matcha%20cookies%20with%20a%20cup%20of%20green%20tea%20on%20a%20minimal%20white%20table%2C%20soft%20natural%20light%2C%20cozy%20lifestyle%20food%20photography&width=900&height=900&seq=tx-matcha-g3&orientation=squarish",
      "https://readdy.ai/api/search-image?query=Overhead%20flat%20lay%20of%20matcha%20cookies%20scattered%20near%20a%20cream%20box%20on%20warm%20white%20surface%2C%20top%20view%2C%20bright%20soft%20light%2C%20clean%20product%20photography&width=900&height=900&seq=tx-matcha-g4&orientation=squarish",
    ],
    description: [
      "抹茶白巧曲奇选用宇治抹茶粉，微苦回甘的茶香与酥松曲奇相得益彰，白巧克力豆增添了温柔的奶香。",
      "甜度控制得恰到好处，吃完一整盒也不会觉得腻。",
    ],
    features: [
      { title: "宇治抹茶粉", desc: "茶香清雅，色泽自然翠绿。" },
      { title: "白巧克力豆", desc: "颗颗点缀，奶香温柔。" },
      { title: "低甜配方", desc: "减糖配方，茶香更突出。" },
      { title: "手工烘焙", desc: "小批量烘焙，保证新鲜酥松。" },
    ],
    specs: [
      { label: "净含量", value: "160g（约 24 枚）/ 盒" },
      { label: "主要配料", value: "小麦粉、发酵黄油、白砂糖、白巧克力、抹茶粉、鸡蛋" },
      { label: "保质期", value: "60 天" },
      { label: "储存方式", value: "常温阴凉处保存，开盒后建议 7 天内食用完" },
      { label: "过敏原提示", value: "含小麦、乳制品、蛋类、大豆" },
    ],
    usage: [
      "开盒即食，建议搭配热茶享用。",
      "可稍作冷藏，口感更清爽。",
      "适合作为伴手礼或下午茶点心。",
    ],
    scenes: ["下午茶", "茶点搭配", "送礼自享", "独处时光"],
  },
];